import React from 'react';
import { createMemoStyles } from '@wds/utils';

/// ///////////////////////// GENERIC START ////////////////////////////
var SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];
/// ///////////////////////// PALETTE START ////////////////////////////
var SEMANTIC_COLORS = ['primary', 'secondary', 'success', 'warning', 'upgrade', 'error', 'info', 'muted'];
var LINK_COLORS = ['link'];
var TYPE_COLORS = ['dark', 'light', 'darkMuted', 'lightMuted', 'link'];
var BACKGROUND_COLORS = ['main', 'light', 'dark', 'overlay', 'accent'];
var BORDER_COLORS = ['main', 'active', 'hover', 'muted'];
var DATA_COLORS = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
/// ///////////////////////// FONT TYPE START ////////////////////////////
var FONT_FAMILY_KEYS = ['base', 'headings', 'icon'];
var FONT_SIZES = ['caption', 'bodySm', 'body', 'cardTitle', 'sectionTitleSm', 'sectionTitle', 'pageTitle', 'hero2', 'hero1'];
var FONT_WEIGHTS = ['light', 'regular', 'medium'];
var FONT_ASSETS = ['base', 'path', 'name', 'versions'];
/// ///////////////////////// SPACING START ////////////////////////////
var SPACING_KEYS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var BORDER_KEYS = ['main', 'hover', 'active', 'muted', 'dark', 'light'];
/// ///////////////////////// RADIUS START ////////////////////////////
var RADIUS_KEYS = ['zero', 'small', 'medium', 'large'];
/// ///////////////////////// SHADOW START ////////////////////////////
var SHADOW_KEYS = ['none', 'sky', 'space'];
/// ///////////////////////// ELEVATION START ////////////////////////////
var ELEVATION_KEYS = ['none', 'sky', 'space'];
/// ///////////////////////// TYPE GUARDS ////////////////////////////
var isColorShape = function (c) {
  return typeof c === 'object' && 'main' in c;
};
var getColor = function (color) {
  return isColorShape(color) ? color.main : color;
};
var basePath$1 = process.env.NODE_ENV !== 'production' ? 'cdn.mtassets.net' : 'cdn.smassets.net';
var fontSize = {
  caption: 12,
  bodySm: 14,
  body: 16,
  cardTitle: 20,
  sectionTitleSm: 24,
  sectionTitle: 28,
  pageTitle: 32,
  hero1: 48,
  hero2: 40
};
var fontWeight = {
  light: 300,
  regular: 400,
  medium: 500
};
var fontFamily = {
  base: "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif",
  headings: "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif",
  icon: 'Mateo'
};
var assets = {
  base: "https://".concat(basePath$1, "/assets/wds-core_4_20_1"),
  path: '/fonts/National2Web',
  name: "'National 2'",
  version: 2
};
var type$1 = {
  assets: assets,
  fontFamily: fontFamily,
  fontSize: fontSize,
  fontWeight: fontWeight
};
var palette$1 = {
  transparent: 'transparent',
  primary: {
    main: '#00BF6F',
    contrast: '#FFFFFF'
  },
  secondary: {
    main: '#6B787F',
    contrast: '#FFFFFF'
  },
  success: {
    main: '#00BF6F',
    contrast: '#FFFFFF'
  },
  warning: {
    main: '#F05B24',
    contrast: '#FFFFFF'
  },
  error: {
    main: '#F05B24',
    contrast: '#FFFFFF'
  },
  info: {
    main: '#2DCCD3',
    contrast: '#333E48'
  },
  upgrade: {
    main: '#F9BE00',
    contrast: '#333E48'
  },
  muted: {
    main: '#D0D2D3',
    contrast: '#333E48'
  },
  link: {
    main: '#007FAA',
    contrast: '#FFFFFF'
  },
  text: {
    dark: '#333E48',
    light: '#FFFFFF',
    darkMuted: '#6B787F',
    lightMuted: '#D0D2D3',
    link: '#007FAA'
  },
  background: {
    main: '#F7F8FA',
    light: '#FFFFFF',
    dark: '#333E48',
    overlay: 'rgba(107, 120, 127, .86)',
    accent: '#EDEEEE'
  },
  border: {
    main: '#D0D2D3',
    active: '#404040',
    hover: '#757575',
    muted: '#EDEEEE'
  },
  data: {
    one: '#507CB6',
    two: '#00BF6F',
    three: '#6BC8CD',
    four: '#F9BE00',
    five: '#7D5E90',
    six: '#DB4D5C',
    seven: '#768086',
    eight: '#D25F90',
    nine: '#A38364',
    ten: '#FF8B4F'
  }
};
var spacing$1 = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 24,
  6: 32,
  7: 48,
  8: 64,
  9: 96,
  10: 128
};
var motion$1 = {
  curve: {
    enter: 'cubic-bezier(0, 0, 0, 1)',
    exit: 'cubic-bezier(1, 0, 1, 1)',
    ease: 'cubic-bezier(.2, 0, .1, 1)',
    easeReverse: 'cubic-bezier(.9, 0, .8, 1)',
    bounceStart: 'cubic-bezier(0, 0, .1, 1)',
    bounceEnd: 'cubic-bezier(.2, 0, 0, 1)'
  },
  fade: {
    speed: {
      slow: 300,
      normal: 200,
      fast: 100
    }
  },
  slide: {
    speed: {
      slow: 450,
      normal: 350,
      fast: 250
    },
    distance: {
      normal: 25,
      near: 5,
      far: 75
    }
  }
};
var border$1 = {
  main: [1, 'solid', getColor(palette$1.border.main)],
  hover: [1, 'solid', getColor(palette$1.border.hover)],
  active: [1, 'solid', getColor(palette$1.border.active)],
  muted: [1, 'solid', getColor(palette$1.border.muted)],
  dark: [1, 'solid', getColor(palette$1.background.dark)],
  light: [2, 'solid', getColor(palette$1.background.light)]
};
var radius$1 = {
  zero: 0,
  small: 4,
  medium: 24,
  large: '50%'
};
var shadow$1 = {
  none: 'none',
  sky: '0 2px 4px 0 rgba(0, 0, 0, 0.14)',
  space: '0 2px 8px 0 rgba(0,0,0,0.14)'
};
var breakpoints$1 = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
var iconSize$1 = {
  sm: 13,
  md: 16,
  lg: 24,
  xl: 32
};
var elevation$1 = {
  none: 0,
  sky: 999,
  space: 9999
};
var theme$1 = {
  type: type$1,
  palette: palette$1,
  spacing: spacing$1,
  motion: motion$1,
  border: border$1,
  radius: radius$1,
  shadow: shadow$1,
  breakpoints: breakpoints$1,
  iconSize: iconSize$1,
  elevation: elevation$1
};
var basePath = process.env.NODE_ENV !== 'production' ? 'cdn.mtassets.net' : 'cdn.smassets.net';
var type = {
  fontFamily: {
    base: "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif",
    headings: "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif",
    icon: 'Mateo'
  },
  fontSize: {
    caption: 12,
    bodySm: 14,
    body: 16,
    cardTitle: 20,
    sectionTitleSm: 24,
    sectionTitle: 28,
    pageTitle: 32,
    hero1: 48,
    hero2: 40
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500
  },
  assets: {
    base: "https://".concat(basePath, "/assets/wds-core_4_20_1"),
    path: '/fonts/National2Web',
    name: "'National 2'",
    version: 2
  }
};
var palette = {
  transparent: 'transparent',
  primary: {
    main: '#008323',
    contrast: '#FFFFFF'
  },
  secondary: {
    main: '#757575',
    contrast: '#FFFFFF'
  },
  success: {
    main: '#008323',
    contrast: '#FFFFFF'
  },
  warning: {
    main: '#F7B500',
    contrast: '#404040'
  },
  error: {
    main: '#CC0000',
    contrast: '#FFFFFF'
  },
  info: {
    main: '#2cb2f1',
    contrast: '#000000'
  },
  upgrade: {
    main: '#ffe11b',
    contrast: '#404040'
  },
  muted: {
    main: '#d0d0d0',
    contrast: '#404040'
  },
  link: {
    main: '#0a7cc1',
    contrast: '#FFFFFF'
  },
  text: {
    dark: '#404040',
    light: '#FFFFFF',
    darkMuted: '#757575',
    lightMuted: '#efefef',
    link: '#0a7cc1'
  },
  background: {
    main: '#F5FAF6',
    light: '#ffffff',
    dark: '#404040',
    overlay: 'rgba(117, 117, 117, .86)',
    accent: '#efefef'
  },
  border: {
    main: '#d0d0d0',
    active: '#404040',
    hover: '#757575',
    muted: '#EDEEEE'
  },
  data: {
    one: '#507CB6',
    two: '#008323',
    three: '#6BC8CD',
    four: '#F9BE00',
    five: '#7D5E90',
    six: '#DB4D5C',
    seven: '#768086',
    eight: '#D25F90',
    nine: '#A38364',
    ten: '#FF8B4F'
  }
};
var spacing = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 24,
  6: 32,
  7: 48,
  8: 64,
  9: 96,
  10: 128
};
var motion = {
  curve: {
    enter: 'cubic-bezier(0, 0, 0, 1)',
    exit: 'cubic-bezier(1, 0, 1, 1)',
    ease: 'cubic-bezier(.2, 0, .1, 1)',
    easeReverse: 'cubic-bezier(.9, 0, .8, 1)',
    bounceStart: 'cubic-bezier(0, 0, .1, 1)',
    bounceEnd: 'cubic-bezier(.2, 0, 0, 1)'
  },
  fade: {
    speed: {
      slow: 300,
      normal: 200,
      fast: 100
    }
  },
  slide: {
    speed: {
      slow: 450,
      normal: 350,
      fast: 250
    },
    distance: {
      normal: 25,
      near: 5,
      far: 75
    }
  }
};
var border = {
  main: [1, 'solid', getColor(palette.border.main)],
  hover: [1, 'solid', getColor(palette.border.hover)],
  active: [1, 'solid', getColor(palette.border.active)],
  muted: [1, 'solid', getColor(palette.border.muted)],
  dark: [1, 'solid', getColor(palette.background.dark)],
  light: [2, 'solid', getColor(palette.background.light)]
};
var radius = {
  zero: 0,
  small: 4,
  medium: 24,
  large: '50%'
};
var shadow = {
  none: 'none',
  sky: '0 2px 4px 0 rgba(0, 0, 0, 0.14)',
  space: '0 2px 8px 0 rgba(0, 0, 0, 0.14)'
};
var breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
var iconSize = {
  sm: 13,
  md: 16,
  lg: 24,
  xl: 32
};
var elevation = {
  none: 0,
  sky: 999,
  space: 9999
};
var theme = {
  type: type,
  palette: palette,
  spacing: spacing,
  motion: motion,
  border: border,
  radius: radius,
  shadow: shadow,
  breakpoints: breakpoints,
  iconSize: iconSize,
  elevation: elevation
};

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var useStyles = createMemoStyles(function (_a) {
  var _b = _a.type,
    assets = _b.assets,
    fontFamily = _b.fontFamily,
    fontWeight = _b.fontWeight,
    fontSize = _b.fontSize;
  var fontPath = "".concat(assets.base).concat(assets.path);
  var fontFaces = FONT_WEIGHTS.map(function (name) {
    // we need this because the font file names are all National2-<Weight>.2.ext
    var upperCaseName = "".concat(name[0].toUpperCase()).concat(name.slice(1));
    var weight = fontWeight[name];
    return {
      fontFamily: assets.name,
      fontWeight: weight,
      fontDisplay: 'swap',
      src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".woff2) format('woff2')"),
      fallbacks: [{
        src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".woff) format('woff')")
      }, {
        src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".eot#iefix) format('embedded-opentype')")
      }]
    };
  });
  return {
    '@font-face': fontFaces,
    '@global': {
      "[class*='wrench'], [class*='wrench']::before, [class*='wrench']::after": {
        fontFamily: fontFamily.base,
        '-webkit-font-smoothing': 'antialiased',
        fontSize: fontSize.body,
        boxSizing: 'border-box',
        padding: 0,
        margin: 0,
        listStyle: 'none'
      }
    }
  };
});
var GlobalStyles = function () {
  useStyles();
  return React.createElement(React.Fragment, null);
};
export { BACKGROUND_COLORS, BORDER_COLORS, BORDER_KEYS, DATA_COLORS, ELEVATION_KEYS, theme as ElevateTheme, FONT_ASSETS, FONT_FAMILY_KEYS, FONT_SIZES, FONT_WEIGHTS, GlobalStyles, LINK_COLORS, RADIUS_KEYS, SEMANTIC_COLORS, SHADOW_KEYS, SIZES, SPACING_KEYS, TYPE_COLORS, theme$1 as WrenchTheme, getColor, isColorShape };